import React from 'react'
import { Field } from '../../form'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import FontAwesome from 'react-fontawesome'
import { Translation } from 'react-i18next'
import mobileView from '../../utils/mobile.utils'

const styles = (theme) => ({
  tablecell: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: '#9e9e9e'
  },
  textField: {
    marginTop: theme.spacing(3),
    minWidth: 200,
    paddingLeft: '5px'
  },
  textField2: {
    marginTop: theme.spacing(3)
  },
  resize: {
    fontSize: '14px'
  },
  margin: {
    margin: theme.spacing(1),
    marginTop: 30
  }
})

const AllowanceRoute = ({
  index,
  classes,
  control,
  remove,
  type,
  disabled
}) => {
  const label =
    type === 'start' ? 'newAllowRow.startLabel' : 'newAllowRow.middleLabel'

  return (
    <Translation>
      {(t) => {
        return (
          <div
            className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
            style={
              type === 'stop'
                ? {
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingTop: mobileView ? '10px' : null
                  }
                : null
            }
          >
            <div
              style={{
                width: type !== 'stop' ? '100%' : '95%'
              }}
            >
              <Field
                name={`startPlace.${index}.route`}
                label={t(label)}
                placeholder={t(label)}
                inputType="autocomplete-places"
                control={control}
                disabled={disabled}
                className={
                  type === 'stop'
                    ? classNames(classes.textField, classes.resize)
                    : classNames(classes.textField2, classes.resize)
                }
              />
            </div>

            {type !== 'stop' ? null : (
              <IconButton
                aria-label="Delete"
                className={classes.margin}
                onClick={() => remove(index)}
                key={index}
                disabled={disabled}
                style={{
                  margin: '14px 0px 0px 6px',
                  padding: '14px 0px 0px 6px'
                }}
              >
                <FontAwesome
                  name="window-close"
                  style={{
                    width: '100%',
                     color: disabled ? '#9e9e9e' : '#F67131'
                  }}
                />
              </IconButton>
            )}
          </div>
        )
      }}
    </Translation>
  )
}

AllowanceRoute.propTypes = {
  classes: PropTypes.object.isRequired,
  control: PropTypes.object.isRequired,
  remove: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
}

export default withStyles(styles)(AllowanceRoute)
